import Search from '@/pages/search_new';
import Subscriptions from '@/pages/subscriptions/subscriptions';
import Vacancy from '@/pages/vacancy/vacancy';
import { requireAuth } from '@/helpers';

export default [
  {
    path: '/',
    redirect: '/sok/bostad',
  },
  {
    path: '/sok/:type?',
    name: 'Search',
    component: Search,
  },
  {
    path: '/bevakning/:type/:code',
    name: 'SearchPrefill',
    component: Search,
  },
  {
    path: '/objekt/:id?',
    name: 'Vacancy',
    component: Vacancy,
  },
  {
    path: '/bevakningar',
    name: 'Subscriptions',
    component: Subscriptions,
    beforeEnter: requireAuth,
  },
];
